export default __webpack_public_path__ + "static/media/telephone_2.16f471f0.png";